__turbopack_context__.v({
  "btn": "AlternatingSection-module__Pg46rW__btn",
  "description": "AlternatingSection-module__Pg46rW__description",
  "image": "AlternatingSection-module__Pg46rW__image",
  "imageBg": "AlternatingSection-module__Pg46rW__imageBg",
  "imageColumn": "AlternatingSection-module__Pg46rW__imageColumn",
  "imageWrapper": "AlternatingSection-module__Pg46rW__imageWrapper",
  "points": "AlternatingSection-module__Pg46rW__points",
  "reverse": "AlternatingSection-module__Pg46rW__reverse",
  "row": "AlternatingSection-module__Pg46rW__row",
  "section": "AlternatingSection-module__Pg46rW__section",
  "tag": "AlternatingSection-module__Pg46rW__tag",
  "textColumn": "AlternatingSection-module__Pg46rW__textColumn",
  "title": "AlternatingSection-module__Pg46rW__title",
});
